import React from 'react';

const ProductList = ({ products, onDelete, onEdit }) => {
  if (!products.length) {
    return (
      <div className="empty-list">
        No products yet. Add one above ↑
      </div>
    );
  }

  return (
    <div className="product-list">
      {products.map((product) => (
        <div className="pl-card" key={product.id}>
          <div className="pl-image">
            {product.image ? (
              <img src={product.image} alt={product.name} />
            ) : (
              <div className="pl-no-image">No Image</div>
            )}
          </div>

          <div className="pl-info">
            <h3>{product.name}</h3>
            {product.shortDesc && <p className="pl-short">{product.shortDesc}</p>}
            <p className="pl-desc">{product.description}</p>
          </div>

          <div className="pl-actions">
            <div
              className="pl-edit"
              onClick={() => onEdit(product)}
              title="Edit product"
            >
              ✎
            </div>
            <div
              className="pl-delete"
              onClick={() => onDelete(product.id)}
              title="Delete product"
            >
              🗑
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProductList;
